import styled from 'styled-components';

const TransitionGroupContainer = styled.div`
    display: flex;
    flex: 1;
    position: relative;
`;

export default TransitionGroupContainer;
